import { render, staticRenderFns } from "./tableShareModal.vue?vue&type=template&id=118f1bf7&scoped=true"
import script from "./tableShareModal.vue?vue&type=script&lang=js"
export * from "./tableShareModal.vue?vue&type=script&lang=js"
import style0 from "./tableShareModal.vue?vue&type=style&index=0&id=118f1bf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118f1bf7",
  null
  
)

export default component.exports